import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Help.css';

const Help = () => {
  const navigate = useNavigate();

  // ADDED: State variables from Home.js
  const [currentLanguage, setCurrentLanguage] = useState('english');
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDSAFormOpen, setIsDSAFormOpen] = useState(false);

  // ADDED: Translations object (simplified version)
  const translations = {
    english: {
      logo: 'FinLink',
      navHome: 'Home',
      navAbout: 'About us',
      navServices: 'Services',
      navInsurance: 'Insurance',
      navDsa: 'Become Partner',
      navFaq: 'FAQ',
      navContact: 'Contact',
      navCareer: 'Career with us',
      navHelp: 'Help Desk',
      partnerButton: 'Login',
      applyButton: 'Become DSA',
      footerAbout: 'Krishna Finconcept Services',
      footerDescription: 'India\'s leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.',
      footerProducts: 'Loan Products',
      footerHome: 'Home Loan',
      footerPersonal: 'Personal Loan',
      footerBusiness: 'Business Loan',
      footerLap: 'Loan Against Property',
      footerCar: 'Car Loan',
      footerEducation: 'Education Loan',
      footerServices: 'Other Services',
      footerCredit: 'Credit Cards',
      footerInsurance: 'Insurance',
      footerGold: 'Gold Loan',
      footerBills: 'Bill Payments',
      footerCreditScore: 'Free Credit Score',
      footerPartner: 'Become Partner',
      footerContact: 'Contact Us'
    },
    hindi: {
      logo: 'फिनलिंक',
      navHome: 'होम',
      navProducts: 'उत्पाद',
      navInsurance: 'बीमा',
      navDsa: 'भागीदार बनें',
      navFaq: 'सामान्य प्रश्न',
      navContact: 'संपर्क करें',
      navCareer: 'करियर हमारे साथ',
      navHelp: 'हेल्प डेस्क',
      partnerButton: 'लॉगिन',
      applyButton: 'डीएसए बनें',
      footerAbout: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज',
      footerDescription: 'भारत का अग्रणी वित्तीय सेवा प्लेटफॉर्म, ग्राहकों को लोन, क्रेडिट कार्ड, बीमा और निवेश उत्पादों के लिए 100+ बैंकिंग भागीदारों से जोड़ता है।',
      footerProducts: 'ऋण उत्पाद',
      footerHome: 'होम लोन',
      footerPersonal: 'पर्सनल लोन',
      footerBusiness: 'बिजनेस लोन',
      footerLap: 'प्रॉपर्टी के खिलाफ लोन',
      footerCar: 'कार लोन',
      footerEducation: 'शिक्षा ऋण',
      footerServices: 'अन्य सेवाएं',
      footerCredit: 'क्रेडिट कार्ड',
      footerInsurance: 'बीमा',
      footerGold: 'गोल्ड लोन',
      footerBills: 'बिल भुगतान',
      footerCreditScore: 'मुफ्त क्रेडिट स्कोर',
      footerPartner: 'भागीदार बनें',
      footerContact: 'हमसे संपर्क करें'
    },
    gujarati: {
      logo: 'ફિનલિંક',
      navHome: 'હોમ',
      navProducts: 'ઉત્પાદનો',
      navInsurance: 'બીમા',
      navDsa: 'ભાગીદાર બનો',
      navFaq: 'પ્રશ્નો-જવાબો',
      navContact: 'સંપર્ક કરો',
      navCareer: 'કારકિર્દી અમારી સાથે',
      navHelp: 'હેલ્પ ડેસ્ક',
      partnerButton: 'લૉગિન',
      applyButton: 'DSA બની જાઓ',
      footerAbout: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ',
      footerDescription: 'ભારતનું અગ્રણી નાણાકીય સેવા પ્લેટફોર્મ, ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ, બીમા અને રોકાણ ઉત્પાદનો માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે.',
      footerProducts: 'લોન ઉત્પાદનો',
      footerHome: 'હોમ લોન',
      footerPersonal: 'પર્સનલ લોન',
      footerBusiness: 'બિઝનેસ લોન',
      footerLap: 'મિલકત સામે લોન',
      footerCar: 'કાર લોન',
      footerEducation: 'એજ્યુકેશન લોન',
      footerServices: 'અન્ય સેવાઓ',
      footerCredit: 'ક્રેડિટ કાર્ડ',
      footerInsurance: 'બીમા',
      footerGold: 'ગોલ્ડ લોન',
      footerBills: 'બિલ પેમેન્ટ',
      footerCreditScore: 'મફત ક્રેડિટ સ્કોર',
      footerPartner: 'ભાગીદાર બનો',
      footerContact: 'અમારો સંપર્ક કરો'
    }
  };

  const t = translations[currentLanguage];

  const handleBack = () => {
    navigate('/');
  };

  const apiServices = [
    {
      id: 'pan',
      title: 'PAN Verification',
      description: 'Verify Permanent Account Number details',
      icon: '/images/pan.png',
      siteUrl: 'https://www.pan.utiitsl.com/PAN_ONLINE/ePANCardHome'
    },
    {
      id: 'digilocker',
      title: 'Digital Locker (DigiLocker)',
      description: 'Access and store digital documents securely',
      icon: '/images/digi.png',
      siteUrl: 'https://accounts.digilocker.gov.in/v3/1a1da55fec0a69a0378ccd1c5a0d34d3cc043c16b945e30af3d43986f853a21b--en'
    },
    {
      id: 'umang',
      title: 'UMANG Services',
      description: 'Unified Mobile Application for New-age Governance',
      icon: '/images/Umang.png',
      siteUrl: 'https://digilocker.meripehchaan.gov.in/signinv2/oauth_partner/%252Foauth2%252F1%252Fconsent%253Flogo%253D1688558665_umang1.png%2526ui_locales%253Den%2526response_type%253Dcode%2526client_id%253DK7O7WFIQ%2526state%253Dwebdigi_hlbIESevuhz7XxrO3El8O8bjFUMtOve%25252BU0wqNRVX3UXc3pGKqt8%25252BA2HQUnxu06W1e307A%25252FjCMEfnMGGEpzuiZQ3yHHNGDI4qzp7XZK3fpOknRoMzIAiLGBQS96d43%25252BuAZRRyHO6eG9iEOA%25252Bn9u3EbG31xFSh4%25252BTWJcdeYuva%25252BNg8qmFTAld8jPJ3fUNxISHpsRcGe1wroJ6Zz49Q36FwjY%25252BouVl4DIOHhHFtCsDzVQtw4imyWdJsjA9imx1sDh9RNoOZz4MiqqQCBYeK3D2whRKdfMW7R9Jpn9e7yvE47%25252BpiGiM0lrxzKOB42S5OmXsKSPqUZZPzSKHGqYlmCZnab040WRQ15Ycp6TIUSJ7GoDJ0ZY0hS4qXQsrrFzx0ze597FQxJ%25252FF8vgqlhvMvElXZhmqincarBgAqJYnOs%25252F0%25252F9vnoX6hCDfFlpVvPUvSbGOGmnoKfSLCa2rFZK%25252F2WKLIDVI7%25252FjPVzwKylr%25252BB6yGTJYKmmLJ8gc6nIE%25252BZEryDgGHyEQMsHI9TtG0Boyka0te1q2nCYMY3y%25252FJ9Qn2J4Kkw1UcJEml2BZmZUYz4ooy1a4Y1hLLqeOiJgqddh2wHmp4w0G5K9LA27Z30N%25252Bn6NXkpttLldmK8Dd0Mx7wtkr%25252FbHAqcNHXjqBe2lsQdlkJuAS0tZ1EJYlweadlOYu4n5xmKfoUW3MAbZ2%25252BIk%25252BoK8DkBV7Uxmd%25252BWQPkcNmUc8TRvCPss6dCpgX0nvqDb7DUZ0G5x5mYfkXJ2fMk8tJz1jqie5URC9M%25252BuhE%25252BKlKGwPHkyA0hsOP6TtVQS2VENL3W3JPp26bVHh7chz8oa7MjM0hkaBK9R%25252FBioYysHXZ4J48NRQjpIOpjm%25252F9CpjU1%25252BH4oykBG7F0mlgpxcpKyD%25252Fp2POwEQichCMrNqXLBPoQ9QO8r9X2M7aE87YvKs%25252BXcJX0z1%25252F5lprGEv4C1wyIcF56Q3OIBz0nRd1UIE02eA1BXPhq9OSW6vFjG8PVZxh0weqiuNyozIovnZtg4aqlKz7QRFdmPbUuEjJL2PD3ccH9L3gUB9IRzNfBtE1Y62f9%25252FYMb147sIvYgcvYazBMZPUNyvvAzWcefqDgpFG1RPnrajgOVzkbgrriDy%25252Bw70FL30ZWf9zOps%25252FE5cM0Mhjdasq8JvP5qJtCxDt9cDKZhSeB8IScrjaOzq2KP2P7JMekhrIWUrDBhmhSCnaaw0ScIPEBoyNV%25252FRr4teO5zIB7W5YRbWxQ%25252Bmu2cjPhwIYkP6VEYv7GcqfjClJHF8LA7LMEu1y0cV2zRyz31vLJAqw462iDaEO8Bi6PwVjlnInNiVci%25252BxvrAc7VmxVqNGmellbLjEzpGw6la%25252Fsg4hMA3OiNl8byXIXGLA09jEiYdG6XVLoCEm5VHfqNKnV45vA%25253D%2526redirect_uri%253Dhttps%25253A%25252F%25252Fapigw.umangapp.in%25252FdigiLockerApi%25252Fgetatkn%2526orgid%253D000112%2526txn%253D696611b811fc3oauth21768296888%2526hashkey%253D797a73dab6b99d90ab4c52c184f7102239e7094c77b61afb9d5158a5ce3780ab%2526requst_pdf%253DY%2526app_name%253DVU1BTkc%25253D%2526signup%253Dsignup'
    },
    {
      id: 'aadhaar',
      title: 'Aadhaar Services',
      description: 'Secure identity verification using Aadhaar with user consent',
      icon: '/images/aadhaar.png',
      siteUrl: 'https://tathya.uidai.gov.in/access/login?role=resident'
    },
    {
      id: 'gst',
      title: 'GST Services',
      description: 'Verify GST registration and returns',
      icon: '/images/income-tax.png',
      siteUrl: 'https://eportal.incometax.gov.in/iec/foservices/#/login'
    },
    {
    "id": "Driving & Vehicle",
    "title": "Driving License & Vehicle Registration",
    "description": "Access DL and RC details via Sarathi/Parivahan",
    "icon": "/images/transport-logo.png",
    "keywords": ["Transport", "Mobility"],
    "iconFallback": { "text": "DL", "color": "#3B82F6" },
    "documentation": "https://apisetu.gov.in/api/transport",
    "status": "Active",
    "category": "Transport",
    "siteUrl": "https://parivahan.gov.in/parivahan/"
  },
  {
    "id": "Court Cases",
    "title": "Court Case Status",
    "description": "Check case status across Indian courts",
    "icon": "/images/court.png",
    "keywords": ["Legal", "Justice"],
    "iconFallback": { "text": "CC", "color": "#EF4444" },
    "documentation": "https://apisetu.gov.in/api/courts",
    "status": "Active",
    "category": "Legal",
    "siteUrl": "https://services.ecourts.gov.in/ecourtindia_v6/"
  },
  {
    "id": "geospatial",
    "title": "Geospatial Data",
    "description": "Access to government geospatial datasets",
    "icon": "/images/geospatial-logo.png",
    "keywords": ["Mapping", "Satellite"],
    "iconFallback": { "text": "GS", "color": "#10B981" },
    "documentation": "https://apisetu.gov.in/api/geospatial",
    "status": "Beta",
    "category": "Data",
    "siteUrl": "https://bhuvan.nrsc.gov.in/"
  },
  {
    "id": "epfo",
    "title": "EPFO Services",
    "description": "Employee Provident Fund Organization APIs",
    "icon": "/images/epfo-logo.png",
    "keywords": ["Pension", "Savings"],
    "iconFallback": { "text": "PF", "color": "#F59E0B" },
    "documentation": "https://apisetu.gov.in/api/epfo",
    "status": "Active",
    "category": "Finance",
    "siteUrl": "https://unifiedportal-mem.epfindia.gov.in/memberinterface/"
  },
  {
    "id": "gst",
    "title": "GST Verification",
    "description": "Verify GST registration and returns",
    "icon": "/images/gst-logo.png",
    "keywords": ["Tax", "Invoice"],
    "iconFallback": { "text": "GST", "color": "#8B5CF6" },
    "documentation": "https://apisetu.gov.in/api/gst",
    "status": "Active",
    "category": "Finance",
    "siteUrl": "https://services.gst.gov.in/services/login"
  },
  {
    "id": "Income Tax",
    "title": "Income Tax Return",
    "description": "Access ITR filing status and details",
    "icon": "/images/itr-logo.png",
    "keywords": ["Taxation", "Filing"],
    "iconFallback": { "text": "IT", "color": "#EC4899" },
    "documentation": "https://apisetu.gov.in/api/itr",
    "status": "Active",
    "category": "Finance",
    "siteUrl": "https://www.incometax.gov.in/iec/foportal/"
  },
  {
    "id": "ration-card",
    "title": "Ration Card Services",
    "description": "Access to Public Distribution System APIs",
    "icon": "/images/ration-card-logo.png",
    "keywords": ["Food", "Subsidy"],
    "iconFallback": { "text": "RC", "color": "#84CC16" },
    "documentation": "https://apisetu.gov.in/api/pds",
    "status": "Active",
    "category": "Welfare",
    "siteUrl": "https://web.umang.gov.in/landing/department/my-ration-gujarat.html"
  },
  {
    "id": "education",
    "title": "Education Records",
    "description": "Access academic records and certificates",
    "icon": "/images/education-logo.png",
    "keywords": ["Academic", "Certificate"],
    "iconFallback": { "text": "ED", "color": "#06B6D4" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Education",
    "siteUrl": "https://digilocker.gov.in/"
  },
  {
    "id": "NCS",
    "title": "National Career Service (NCS)",
    "description": "Platform for job search, career counseling, and connecting job seekers with employers.",
    "icon": "/images/education-logo.png",
    "keywords": ["Jobs", "Employment"],
    "iconFallback": { "text": "JS", "color": "#6366F1" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Employment",
    "siteUrl": "https://www.ncs.gov.in/"
  },
  {
    "id": "SWAYAM",
    "title": "SWAYAM",
    "description": "Access free online courses from school to university level, offered by the Government.",
    "icon": "/images/education-logo.png",
    "keywords": ["Courses", "Learning"],
    "iconFallback": { "text": "SW", "color": "#F97316" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Education",
    "siteUrl": "https://swayam-sso.swayam2.ac.in/signin?response_type=code&client_id=swayam-central-production&redirect_uri=%2F&state=iFQjkCbR9OCiAHa4JfNFolf7k2MQjS%22"
  },
  {
    "id": "NSP",
    "title": "National Scholarship Portal (NSP)",
    "description": "One-stop platform for application, receipt, and distribution of various scholarships.",
    "icon": "/images/education-logo.png",
    "keywords": ["Scholarship", "Aid"],
    "iconFallback": { "text": "SP", "color": "#8B5CF6" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Education",
    "siteUrl": "https://scholarships.gov.in/"
  },
  {
    "id": "Health Insurance",
    "title": "Health Insurance",
    "description": "Ayushman Bharat PM-JAY - Check eligibility, find hospitals, and access scheme details.",
    "icon": "/images/education-logo.png",
    "keywords": ["Insurance", "Health"],
    "iconFallback": { "text": "HI", "color": "#10B981" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Health & Welfare",
    "siteUrl": "https://pmjay.gov.in/"
  },
  {
    "id": "Vaccination",
    "title": "Vaccination",
    "description": "Co-WIN - Portal for COVID-19 vaccination registration and certificate download.",
    "icon": "/images/education-logo.png",
    "keywords": ["Vaccine", "Health"],
    "iconFallback": { "text": "VC", "color": "#EF4444" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Health & Welfare",
    "siteUrl": "https://selfregistration.cowin.gov.in/"
  },
  {
    "id": "Women & Child",
    "title": "Women & Child",
    "description": "Poshan Tracker - Platform for tracking nutrition and health of women and children.",
    "icon": "/images/education-logo.png",
    "keywords": ["Nutrition", "Childcare"],
    "iconFallback": { "text": "WC", "color": "#EC4899" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Health & Welfare",
    "siteUrl": "https://poshanabhiyaan.gov.in/login"
  },
  {
    "id": "MyGov",
    "title": "MyGov",
    "description": "Citizen engagement platform for discussions, surveys, and volunteering for government initiatives.",
    "icon": "/images/education-logo.png",
    "keywords": ["Engagement", "Citizen"],
    "iconFallback": { "text": "MG", "color": "#3B82F6" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Digital Infrastructure",
    "siteUrl": "https://auth.mygov.in/user/login?destination=oauth2/authorize"
  },
  {
    "id": "OGD",
    "title": "Open Government Data (OGD)",
    "description": "Massive repository of publicly available government datasets for analysis and innovation.",
    "icon": "/images/education-logo.png",
    "keywords": ["Data", "Open Source"],
    "iconFallback": { "text": "OD", "color": "#6B7280" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Digital Infrastructure",
    "siteUrl": "https://data.gov.in/"
  },
  {
    "id": "API Setu",
    "title": "API Setu",
    "description": "A gateway for developers to access various government APIs (like those in your initial list).",
    "icon": "/images/education-logo.png",
    "keywords": ["Developer", "Gateway"],
    "iconFallback": { "text": "API", "color": "#F59E0B" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Digital Infrastructure",
    "siteUrl": "https://partners.apisetu.gov.in/signin"
  },
  {
    "id": "Passport Services",
    "title": "Passport Services",
    "description": "Passport Seva - Apply for new passport, check status, schedule appointments.",
    "icon": "/images/education-logo.png",
    "keywords": ["Travel", "Document"],
    "iconFallback": { "text": "PS", "color": "#84CC16" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Digital Infrastructure",
    "siteUrl": "https://services1.passportindia.gov.in/forms/PreLogin?_gl=1%2Ajcdwj7%2A_ga%2AMTE4MTcwMzcyMy4xNzY4NTU4MDAw%2A_ga_B4255W3J9F%2AczE3Njg1NTc5OTkkbzEkZzEkdDE3Njg1NTgwMTIkajQ3JGwwJGgw%2A_ga_JTJJBP5DNH%2AczE3Njg1NTc5OTkkbzEkZzEkdDE3Njg1NTgwMTIkajQ3JGwwJGgw%22"
  },
  {
    "id": "Rural Employment",
    "title": "Rural Employment",
    "description": "MNREGA - Manage job cards, check muster rolls, and payments for rural employment.",
    "icon": "/images/education-logo.png",
    "keywords": ["Employment", "Rural"],
    "iconFallback": { "text": "RE", "color": "#F97316" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Employment",
    "siteUrl": "https://nrega.dord.gov.in/MGNREGA_new/Nrega_home.aspx"
  },
  {
    "id": "Company Compliance",
    "title": "Company Compliance",
    "description": "MCA21 - Ministry of Corporate Affairs portal for company filings, LLP registration.",
    "icon": "/images/education-logo.png",
    "keywords": ["Corporate", "Compliance"],
    "iconFallback": { "text": "MC", "color": "#14B8A6" },
    "documentation": "https://apisetu.gov.in/api/education",
    "status": "Active",
    "category": "Corporate",
    "siteUrl": "https://www.mca.gov.in/content/mca/global/en/foportal/fologin.html"
  }
  ];

  const [searchQuery, setSearchQuery] = useState('');

  const filteredServices = apiServices.filter(service => {
    return service.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      service.description.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const handleSiteClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="help-container">
      {/* ========== UPDATED: Header from Home.js ========== */}
     

      {/* ========== UPDATED: Mobile Menu from Home.js ========== */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-sidebar-header">
          <div className="logo">
            <img
              src="/images/kfs-logo.png"
              alt="Finconcept Logo"
              className="header-logo"
            />
          </div>
          <button
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            ×
          </button>
        </div>

        <div className="mobile-nav-links">
          {/* Home */}
          <a href="/" onClick={() => setIsMobileMenuOpen(false)}>{t.navHome}</a>

          {/* About Us */}
          <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>{t.navAbout}</a>

          {/* Services with sub-menu for mobile */}
          <div className="mobile-dropdown">
            <a href="#services" onClick={() => setIsMobileMenuOpen(false)}>{t.navServices}</a>
            <div className="mobile-dropdown-content">
              {/* All Loan with submenu for mobile */}
              <div className="mobile-submenu">
                <a href="#all-loans" className="mobile-submenu-trigger">
                  All Loan <span className="mobile-submenu-arrow">▼</span>
                </a>
                <div className="mobile-submenu-content">
                  <a href="/home-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Home Loan</a>
                  <a href="/personal-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Personal Loan</a>
                  <a href="/loan-against-property" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Loan Against Property</a>
                  <a href="/business-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Business Loan</a>
                  <a href="/car-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Car Loan</a>
                  <a href="/education-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Education Loan</a>
                  <a href="/gold-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Gold Loan</a>
                </div>
              </div>

              <a href="/insurance" onClick={() => setIsMobileMenuOpen(false)}>Insurance</a>
              <a href="/website" onClick={() => setIsMobileMenuOpen(false)}>Website</a>
              <a href="/crm" onClick={() => setIsMobileMenuOpen(false)}>CRM</a>
            </div>
          </div>

          {/* Help Desk */}
          <a href="/help" onClick={() => setIsMobileMenuOpen(false)}>{t.navHelp}</a>

          {/* Contact Us */}
          <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>{t.navContact}</a>
        </div>

        <div className="mobile-nav-buttons">
          <button className="mobile-partner-btn">{t.partnerButton}</button>
          <button className="mobile-apply-btn">{t.applyButton}</button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <button
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* ========== ORIGINAL HELP PAGE CONTENT ========== */}
      <main className="help-main">
        {/* Search Bar */}
        <section className="help-search-section">
          <div className="help-search-container">
            <input
              type="text"
              placeholder="Search Services"
              className="help-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="help-search-icon">🔍</span>
          </div>
        </section>

        {/* API Services Grid */}
        <section className="help-services-section">
          <div className="help-services-grid">
            {filteredServices.map((service) => (
              <div key={service.id} className="help-service-card">
                <div className="help-service-header">
                  <div className="help-service-icon-wrapper">
                    <img
                      src={service.icon}
                      alt={`${service.title} logo`}
                      className="help-service-icon"
                    />
                  </div>
                </div>

                <div className="help-service-content">
                  <h3 className="help-service-title">{service.title}</h3>
                  <p className="help-service-desc">{service.description}</p>
                </div>

                <div className="help-service-actions">
                  <button
                    className="help-try-btn"
                    onClick={() => handleSiteClick(service.siteUrl)}
                  >
                    <span className="help-btn-icon">🚀</span>
                    Go To Site
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredServices.length === 0 && (
            <div className="help-no-results">
              <span className="help-no-results-icon">🔍</span>
              <h3>No APIs Found</h3>
              <p>Try a different search term</p>
            </div>
          )}
        </section>
      </main>

      
    </div>
  );
};

export default Help;
